<div class="padded-side-nav">
    @if (loading===false){
    <p>
        This window is used to create or edit currently selected task group.
        When setting up the 'Upload file' task you must provide an absolute path to the directory of you device (must
        end with a slash: /), while it is also possible to rename the
        selected file in the process by providing a new name.
        In case of the 'Download file' task, a full path to the file is required.
    </p>
    <br />
    @if (finishedLoading) {
    <mat-form-field class="full-width-input">
        <mat-label>Task group name</mat-label>
        <input type="text" matInput placeholder="Task group name" [formControl]="TaskGroupNameControl" required>
        @if (TaskGroupNameControl.errors && TaskGroupNameControl.hasError('required')) {
        <mat-error>Task group name is required</mat-error>
        }
    </mat-form-field>
    <div class="task-name-type-container">
        <mat-form-field class="task-name">
            <mat-label>Task name</mat-label>
            <input type="text" matInput placeholder="Task name" [formControl]="TaskNameControl" required>
            @if (TaskNameControl.errors && TaskNameControl.hasError('required')) {
            <mat-error>Task name is required</mat-error>
            }
        </mat-form-field>
        <!-- TODO: Task type here -->
        <mat-form-field class="task-type">
            <mat-label>Task type</mat-label>
            <mat-select [formControl]="TaskTypeControl" required>
                @for(option of taskTypes; track option) {
                <mat-option [value]="option">{{option}}</mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>
    <mat-form-field class="full-width-input">
        <mat-label>Command</mat-label>
        <textarea matInput placeholder="Command" [formControl]="CommandControl" required cdkTextareaAutosize
            cdkAutosizeMinRows="20"></textarea>
        @if (CommandControl.errors && CommandControl.hasError('required')) {
        <mat-error>Command is required</mat-error>
        }
    </mat-form-field>
    <mat-form-field class="full-width-input">
        <mat-label>Timeout (seconds)</mat-label>
        <input type="text" matInput placeholder="Timeout (seconds)" type="number" [formControl]="TimeoutControl"
            required>
        @if (TimeoutControl.errors && TimeoutControl.hasError('required')) {
        <mat-error>Timeout is required</mat-error>
        }
    </mat-form-field>
    <mat-form-field class="full-width-input">
        <mat-label>Acceptable codes</mat-label>
        <mat-chip-grid #chipGrid aria-label="Enter fruits">
            @for (code of acceptableCodes; track code) {
            <mat-chip-row (removed)="removeAcceptableCode(code)" [editable]="true"
                (edited)="editAcceptableCodes(code, $event)" [aria-description]="'Press enter to edit'">
                {{code}}
                <button matChipRemove [attr.aria-label]="'Remove ' + code">
                    <mat-icon>cancel</mat-icon>
                </button>
            </mat-chip-row>
            }
            <input placeholder="New acceptable code..." [matChipInputFor]="chipGrid"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                (matChipInputTokenEnd)="addAcceptableCode($event)" />
        </mat-chip-grid>
        @if (acceptableCodesError != null) {
        <mat-error>{{acceptableCodesError}}</mat-error>
        }
    </mat-form-field>
    <mat-checkbox style="margin-right: 30px;" [checked]="StopOnFailureControl.value" [required]="true"
        (change)="updateStopOnFailureControl($event)">Stop task group on failure</mat-checkbox>
    @if (taskData != null) {
    <button mat-raised-button (click)="submitTask()"><i class="material-icons">save</i> Update</button>
    } @else {
    <button mat-raised-button (click)="submitTask()"><i class="material-icons">add</i> Add</button>
    }
    <button mat-raised-button (click)="cancel()"><i class="material-icons">cancel</i> Cancel</button>
    }
    }@else {
    <div style="display: flex; justify-content: center;">
        <mat-spinner [diameter]="40"></mat-spinner>
    </div>
    }
</div>